$(document).ready(() => {



  $('.modal-close').each( function() {
    $(this).click(function(e) {
      e.preventDefault()
      const modalName = $(this).closest('.modal').data('modalName');
      if (modalName) {
        toggleModal(modalName)
      }
    })
  })

  $('.open-modal').click( function(e) {
    const modalName = $(this).data('modalName');
    e.preventDefault()
    if (modalName) {
      toggleModal(modalName)
    }

  })

  document.onkeydown = function(evt) {
    evt = evt || window.event
    var isEscape = false
    if ("key" in evt) {
      isEscape = (evt.key === "Escape" || evt.key === "Esc")
    } else {
      isEscape = (evt.keyCode === 27)
    }
    if (isEscape && document.body.classList.contains('modal-active')) {

      $('.modal-close').each( function() {
        $(this).click(function(e) {
          e.preventDefault()
          const modalName = $(this).closest('.modal').data('modalName');
          if (modalName) {
            toggleModal(modalName)
          }
        })
      })
    }
  };


  function toggleModal (modalName) {
    if (modalName) {
      const body = document.querySelector('body')
      const modal = document.querySelector(`.${modalName}-modal`)
      modal.classList.toggle('opacity-0')
      modal.classList.toggle('pointer-events-none')
      body.classList.toggle(`${modalName}-modal-active`)
      body.classList.toggle(`modal-active`)

      $(modal).find('.search-input').focus();
      // Set the placeholder to make floating labels work.
      require('./form-fixes');
    }
  }

})
